import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../frappe/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return new Promise((resolve, reject) => {
    authService.getLoggedInUser()
      .then((user) => resolve(true))
      .catch((error) => {
        router.navigate(['auth/login'])
        resolve(false);
      });
  });
};
